// extracted by mini-css-extract-plugin
module.exports = {"root":"FeaturedTag_root__wbjt1"};